// extracted by mini-css-extract-plugin
export var divider = "_3p-0";
export var dividerText = "_3p-1";